{
  "zh-TW": {
    "meta": {
      "description": "FleetYards.net, Your Database for all Information related to Ships from “Star Citizen“."
    },
    "model": {
      "focus": "定位",
      "classification": "分類",
      "size": "尺寸",
      "beam": "寬度",
      "cargo": "貨物",
      "cargoWithModules": "含模組",
      "personalInventory": "飛船庫存",
      "beds": {
        "one": "%{count} 個床位",
        "other": "%{count} 個床位"
      },
      "crew": "船員",
      "speed": "速度",
      "scmSpeed": "SCM速度",
      "scmSpeedBoosted": "SCM速度增強",
      "reverseSpeedBoosted": "倒車速度增強",
      "maxSpeed": "最大速度",
      "scm": "SCM",
      "max": "最大",
      "groundMaxSpeed": "最大速度",
      "groundReverseSpeed": "倒車速度",
      "pitch": "俯仰",
      "pitchBoosted": "俯仰增強",
      "yaw": "偏航",
      "yawBoosted": "偏航增強",
      "roll": "滾轉",
      "rollBoosted": "滾轉增強",
      "price": "價格",
      "groundAcceleration": "加速度",
      "compare": {
        "groundMaxSpeed": "地面最大速度",
        "groundReverseSpeed": "地面倒車速度",
        "groundAcceleration": "地面加速度",
        "groundDeceleration": "地面減速度"
      },
      "quantumFuelTankSize": "量子燃料",
      "hydrogenFuelTankSize": "燃料",
      "pledgePrice": "質押價格",
      "height": "高度",
      "length": "長度",
      "mass": "質量",
      "manufacturer": "製造商",
      "hardpoints": "掛載點",
      "weapons": "武器",
      "equipment": "裝備",
      "variants": "變體",
      "productionStatus": "生產狀態",
      "propulsion": "推進",
      "modular": "模組化",
      "soldAt": "在哪裡出售?",
      "rentalAt": "在哪裡租賃?",
      "poweredByUex": "資料由 UEX 提供",
      "lastUpdatedAt": "最後更新時間?"
    },
    "component": {
      "manufacturer": "製造商",
      "size": "尺寸"
    },
    "availability": {
      "soldAt": "Sold at",
      "boughtAt": "Bought at"
    },
    "resources": {
      "models": "飛船",
      "hardpoints": "掛載點",
      "images": "圖片"
    },
    "pagination": {
      "previous": "Previous Page",
      "next": "Next Page",
      "gap": "&hellip;"
    }
  }
}
